import { useEffect } from "react";

const BASE_URL = "https://theliedetective.co.za";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/358a2a89-6a4d-4d11-930d-7a6187aaa4cb/images/c7c542acfea72c3dbeaed57204062f7e4775da01624ef880db1104f0309fd225.png";

const defaultMeta = {
  title: "The Lie Detective | Professional Polygraph Services in South Africa",
  description: "Professional polygraph examination services across Africa. Trusted by corporates, legal professionals, and individuals.",
};

export function usePageSEO({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title 
      ? `${title} | The Lie Detective`
      : defaultMeta.title;
    const fullDescription = description || defaultMeta.description;
    const fullUrl = `${BASE_URL}${path}`;

    // Update title
    document.title = fullTitle;

    // Helper to update or create meta tag
    const setMeta = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      }
    };

    // Update canonical
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", fullUrl);
    }

    // Update meta tags
    setMeta('meta[name="title"]', "content", fullTitle);
    setMeta('meta[name="description"]', "content", fullDescription);
    
    // Update OG tags
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", fullDescription);
    setMeta('meta[property="og:url"]', "content", fullUrl);
    setMeta('meta[property="og:image"]', "content", OG_IMAGE);
    
    // Update Twitter tags
    setMeta('meta[property="twitter:title"]', "content", fullTitle);
    setMeta('meta[property="twitter:description"]', "content", fullDescription);
    setMeta('meta[property="twitter:url"]', "content", fullUrl);
    setMeta('meta[property="twitter:image"]', "content", OG_IMAGE);

    // Cleanup - reset to defaults when leaving page
    return () => {
      document.title = defaultMeta.title;
      const defaultUrl = BASE_URL;
      
      const canonicalEl = document.querySelector('link[rel="canonical"]');
      if (canonicalEl) canonicalEl.setAttribute("href", defaultUrl);
      
      setMeta('meta[name="title"]', "content", defaultMeta.title);
      setMeta('meta[name="description"]', "content", defaultMeta.description);
      setMeta('meta[property="og:title"]', "content", defaultMeta.title);
      setMeta('meta[property="og:description"]', "content", defaultMeta.description);
      setMeta('meta[property="og:url"]', "content", defaultUrl);
      setMeta('meta[property="twitter:title"]', "content", defaultMeta.title);
      setMeta('meta[property="twitter:description"]', "content", defaultMeta.description);
      setMeta('meta[property="twitter:url"]', "content", defaultUrl);
    };
  }, [title, description, path]);
}
